module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/icons-download-34fd4b3f67057582ab5768be9323c459.svg";